module.exports = __webpack_public_path__ + "static/media/submit-documentation.80f40334.aif";